import React from 'react';
import withApollo from 'lib/withApollo';
import { allHelpPosts } from 'contentlayer/generated';
import Footer from 'components/General/Footer';
import HelpArticle from 'components/HelpCenter/HelpArticle';
import { getBlurDataURL } from 'helpers/getBlurDataURL';
import DashboardPage from 'components/Dashboard/DashboardPage';
import { getUser } from 'helpers/token';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

const HelpArticlePage = ({ post, images, relatedArticles }) => {
  const router = useRouter();

  const [user, setUser] = useState(null);

  useEffect(() => {
    setUser(getUser());
  }, []);

  const { open } = router.query;

  const generatedOgImage = `https://tfog.b-cdn.net/api/post?title=${encodeURIComponent(
    post.title.length < 15
      ? `TravelFeed Help Center: ${post.title}`
      : post.title,
  )}&image=${encodeURIComponent(
    'https://img.travelfeed.io/tvt3st%2F2023-10-12-10-10-618-help-center-question-mark-jpg',
  )}`;

  return (
    <>
      <DashboardPage
        ogImage={generatedOgImage}
        justTitle={`${post.title} - TravelFeed Help Center`}
        description={post.summary}
        showForAnyone
        open={open}
        label="help"
        content={
          <>
            <HelpArticle
              post={post}
              images={images}
              relatedArticles={relatedArticles}
            />
            {user === undefined && <Footer />}
          </>
        }
      />
    </>
  );
};

export async function getStaticPaths() {
  // Get a list of valid post paths.
  const paths = allHelpPosts.map(post => ({
    params: { slug: post.slug },
  }));

  return { paths, fallback: false };
}

export async function getStaticProps(context) {
  // Find the post for the current page.
  const post = allHelpPosts.find(post => post.slug === context.params.slug);

  // Return notFound if the post does not exist.
  if (!post) return { notFound: true };

  const [images] = await Promise.all([
    await Promise.all(
      post.images.map(async src => ({
        src,
        blurDataURL: await getBlurDataURL(src),
      })),
    ),
  ]);

  const relatedArticles = (
    (post.related &&
      post.related.map(slug =>
        allHelpPosts.find(post => post.slug === slug),
      )) ||
    []
  ).map(post => ({ title: post.title, slug: post.slug }));

  // Return the post as page props.
  return { props: { post, images, relatedArticles } };
}

export default withApollo(HelpArticlePage);
